/**
 * Calcula el peso de voto basado en la familia de blockchain
 * @param {number} votes - Número de votos
 * @param {string} chainFamily - Familia de blockchain ('TELOS', 'XPR')
 * @returns {number} - Peso de voto calculado
 */
export const calculateVoteWeight = (votes, chainFamily) => {
  if (chainFamily === 'TELOS') {
    return votes / 10000;
  } else if (chainFamily === 'XPR') {
    const epoch = 946684800000.0;
    const now = Date.now();
    const firstcalc = (now / 1000) - (epoch / 1000);
    const floor = Math.floor(firstcalc / (86400 * 7)) / 52;
    const weight = Math.pow(2, floor);
    return votes / weight / 10000;
  }
  return votes;
};

/**
 * Recompensa diaria estimada de un productor de Telos, como la reparte el
 * contrato eosio.system (producer_pay.cpp, claimrewards_snapshot):
 *  - Bote mensual = min(189000 × precio^-0.516, 315000) TLOS. El contrato usa la
 *    media de 30 días del oráculo Delphi; aquí se pasa el precio que tengamos
 *    (por debajo de ~0,37 USD da igual: el bote está en el tope).
 *  - Se reparte entre los primeros 35 activos en escalera:
 *    top 21 → 2 × (1,20 … 0,80); standby 22.º–35.º → 1,20 … 0,94 (−0,02 por puesto).
 * @param {number} position - Puesto entre los productores activos (1 = más votado)
 * @param {number} tokenPrice - Precio de TLOS en USD
 * @param {number} activeCount - Número de productores activos
 * @returns {number} - TLOS al día
 */
const MAX_PAID_PRODUCERS = 35;

const telosRewardMultiplier = (i) => (i <= 21 ? (2 * (122 - 2 * i)) / 100 : (164 - 2 * i) / 100);

export const calculateTelosRewards = (position, tokenPrice, activeCount) => {
  const paid = Math.min(activeCount, MAX_PAID_PRODUCERS);
  if (!tokenPrice || position < 1 || position > paid) return 0;

  const monthly = Math.min(189000 * Math.pow(tokenPrice, -0.516), 315000);
  const daily = (monthly * 12) / 364; // el "año" del contrato son 52 semanas

  let sumOfMultipliers = 0;
  for (let i = 1; i <= paid; i++) sumOfMultipliers += telosRewardMultiplier(i);

  return (daily / sumOfMultipliers) * telosRewardMultiplier(position);
};
